import JwtBaseClient from './JwtBaseClient';

class TransportGatewayClient {
  constructor() {
    this.jwtBaseClient = new JwtBaseClient(import.meta.env.VITE_TRANSPORT_MARKETPLACE_GATEWAY_BASE_URI, 'response.data');
    this.gatePassUri = '/api/v1/gate-pass/upload';
    this.decodeVinUri = '/api/v1/decode/vin';
    this.transportPromoUri = '/api/v1/transport-promo';
    this.searchRequestUri = '/api/v1/transport-request/filter';
    this.updateRequestUri = '/api/v1/transport-request';
    this.getOffPlatformTransportQuoteUri = '/api/v1/transport-quote';
    this.createOffPlatformBulkRequestsUri = '/api/v1/transport-request/off-platform/bulk';
    this.createBulkRequestsUri = '/api/v1/transport-request/bulk';
    this.formDataHeader = {
      'Content-Type': 'multipart/form-data',
    };
  }

  uploadGatePass(payload) {
    return this.jwtBaseClient.post(this.gatePassUri, payload, this.formDataHeader);
  }

  addGatePassToRequest(jobId, gatePassFileKey) {
    const payload = {
      gatePassFileKey,
    };

    return this.jwtBaseClient.put(`${this.updateRequestUri}/${jobId}`, payload);
  }

  removeGatePass(jobId) {
    return this.jwtBaseClient.put(`${this.updateRequestUri}/${jobId}`, { gatePassFileKey: '' });
  }

  getDecodedVin(vin) {
    return this.jwtBaseClient.get(`${this.decodeVinUri}/${vin}`);
  }

  getOffPlatformTransportQuote(payload) {
    return this.jwtBaseClient.post(`${this.getOffPlatformTransportQuoteUri}`, payload);
  }

  createOffPlatformBulkRequests(payload) {
    return this.jwtBaseClient.post(`${this.createOffPlatformBulkRequestsUri}`, payload);
  }

  createBulkRequests(payload) {
    return this.jwtBaseClient.post(`${this.createBulkRequestsUri}`, payload);
  }

  getTransportationRequests(
    page,
    size,
    sort,
    search,
    statuses,
  ) {
    const payload = {
      statuses,
      search,
    };

    const query = `page=${page}&size=${size}&sort=${sort || 'createdDate,desc'}`;

    return this.jwtBaseClient.post(
      `${this.searchRequestUri}?${query}`,
      payload,
      null,
      null,
      1,
    );
  }

  getPromotions() {
    return this.jwtBaseClient.get(`${this.transportPromoUri}`);
  }

  getTransportContactByDealer(dealerId) {
    return this.jwtBaseClient.get(`/api/v1/dealer/${dealerId}/transport-contact`);
  }
}
export default TransportGatewayClient;
